<div fxLayout="column" fxFlexFill>
  <div fxLayout="column" fxFlexFill class="spinner-container" *ngIf="dataSource.loading$ | async">
    <mat-spinner></mat-spinner>
  </div>
  <div fxFlex="auto" fxFlexFill class="table-container">
    <mat-table [dataSource]="dataSource" multiTemplateDataRows class="regular-table responsive"
               matSort matSortActive="name" matSortDirection="desc" matSortDisableClear>

      <ng-container matColumnDef="name">
        <mat-header-cell *matHeaderCellDef mat-sort-header="name">Name</mat-header-cell>
        <mat-cell *matCellDef="let row">
          <span class="mobile-label">Name:</span>
          <span>
            <a *ngIf="hasEditAccess" [routerLink]="[detailsUrl, row.id]">
              {{ row.name }}
            </a>
            <span *ngIf="!hasEditAccess">{{ row.name }}</span>
          </span>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="description">
        <mat-header-cell *matHeaderCellDef mat-sort-header="description">Description</mat-header-cell>
        <mat-cell *matCellDef="let row">
          <span class="mobile-label">Description:</span>
          <span>{{ row.description }}</span>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="eventType">
        <mat-header-cell *matHeaderCellDef mat-sort-header="eventType">Event Type</mat-header-cell>
        <mat-cell *matCellDef="let row">
          <span class="mobile-label">Event Type:</span>
          <span>{{ row.eventType }}</span>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="enabled">
        <mat-header-cell *matHeaderCellDef mat-sort-header="enabled">Is Enabled</mat-header-cell>
        <mat-cell *matCellDef="let row">
          <span class="mobile-label">Is Enabled:</span>
          <span>{{ row.enabled | yesno }}</span>
        </mat-cell>
      </ng-container>

      <!-- Header and Row Declarations -->
      <mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></mat-header-row>
      <mat-row *matRowDef="let row; columns: displayedColumns" class="call-logs-row"></mat-row>
    </mat-table>
  </div>
  <mat-paginator fxFlex="initial" [length]="dataSource.dataCount$ | async" [pageSize]="100"></mat-paginator>
</div>
